import { render } from "./LoginLinkSent.vue?vue&type=template&id=6c497edf&scoped=true&ts=true"
import script from "./LoginLinkSent.vue?vue&type=script&lang=ts"
export * from "./LoginLinkSent.vue?vue&type=script&lang=ts"

import "./LoginLinkSent.vue?vue&type=style&index=0&id=6c497edf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c497edf"]])

export default __exports__